import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FAQ from "../components/FAQ";

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <About />
      {/* <FAQ /> */}
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
